import invoices from "./invoices";

export default {
	mixins: [
		invoices,
	],

	data() {
		return {
			changed: false,
			shake: false,
			disableTaskShake: false,
		};
	},

	methods: {
		shakeTask(delay = 1000, external = true) {
			if (this.disableTaskShake) {
				return;
			}

			if (external) {
				this.disableTaskShake = true;
			}

			setTimeout(() => {
				this.changed = true;
			}, delay);

			setTimeout(() => {
				this.changed = false;
				this.disableTaskShake = false;
			}, delay + 3000);
		},
		triggerTask(task) {
			if (task.complete) {
				return;
			}
			let actions = {
				confirmPersonalDetails: () => {
					this.showConfirmClientDetailsModal();
				},
				confirmPropertyDetails: () => {
					this.showConfirmPropertyDetailsModal();
				},
				signClientContracts: () => {
					this.$vmodal.replace({
						component: () => import("@/apps/clientPortal/modals/SignClientContracts.vue"),
					});
				},
				payOutstandingInvoices: () => {
					this.$vmodal.replace({
						component: () => import("@/apps/clientPortal/modals/PayInvoices.vue"),
					});
				},
				completeIdChecks: () => {
					this.showCompleteIdChecksModal();
				},
				completeProofOfFunds: () => {
					this.$vmodal.replace({
						component: () => import("@/apps/clientPortal/modals/CompleteProofOfFunds.vue"),
					});
				},
				completeProtocolPacks: () => {
					this.$vmodal.replace({
						component: () => import("@/apps/clientPortal/modals/CompleteProtocolPacks.vue"),
					});
				},
				completeLandTaxCalculations: () => {
					this.$vmodal.replace({
						component: () => import("@/apps/clientPortal/modals/CompleteLandTaxCalculations.vue"),
					});
				},
			};

			let action = actions[task.key];

			if (!action) {
				return;
			}

			return actions[task.key]();
		},
		showBlockingTasksModal(task, action) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/BlockingTasks.vue"),
				props: {
					task: task,
					action: action,
				},
			});
		},
		taskClass(task) {
			return {
				"task-list__task--complete": task.complete,
			};
		},
		showNextTaskModal(previousTaskKey = null) {
			this.$vmodal.open({
				component: () => import("@/apps/clientPortal/modals/NextTask.vue"),
				props: {
					previousTaskKey: previousTaskKey,
				},
			});
		},
		showConfirmClientDetailsModal() {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/ConfirmClientDetails.vue"),
			});
		},
		showConfirmPropertyDetailsModal() {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/ConfirmPropertyDetails.vue"),
			});
		},
		showClientDetailsModal(client) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/ClientDetails.vue"),
				props: {
					clientId: client.id,
				},
			});
		},
		showPropertyDetailsModal(instruction) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/views/instruction/components/modals/PropertyDetails.vue"),
				props: {
					instructionId: instruction.id,
				},
			});
		},
		showClientContractModal(instruction) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/views/instruction/components/modals/ClientContract.vue"),
				props: {
					instructionId: instruction.id,
				},
			});
		},
		showPayInvoiceModal(invoice) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/PayInvoice.vue"),
				props: {
					invoiceId: invoice.id,
				},
			});
		},
		showProofOfFundsModal(instruction, action = null) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/info/ProofOfFunds.vue"),
				props: {
					instruction: instruction,
					action: action,
				},
			});
			// this.$vmodal.replace({
			// 	component: () => import("@/apps/clientPortal/views/instruction/components/modals/ProofOfFunds.vue"),
			// 	props: {
			// 		instructionId: instruction.id,
			// 		goToContributionOnOpen: action === "contribution",
			// 		goToSourceOnOpen: action === "source",
			// 	},
			// });
		},
		showProtocolPackModal(instruction) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/ProtocolPack.vue"),
				props: {
					instructionId: instruction.id,
				},
			});
		},
		openTasksModal(instruction = null) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/Tasks.vue"),
				props: {
					instruction: instruction,
				},
			});
		},
		showCompleteIdChecksModal() {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/CompleteIdChecks.vue"),
			});
		},
		openIdCheckReminderModal(client) {
			this.$vmodal.replace({
				component: () => import("@/apps/clientPortal/modals/IdCheckReminder.vue"),
				props: {
					client: client,
				},
			});
		},
	},

	watch: {
		"nextTask.key": {
			handler() {
				this.shakeTask(0, false);
			},
		},
	},
};
